import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import PlantillaModal from "../PlantillaModal";
import TablaCompra from "../tablas/TablaCompra";
import { toast } from "react-toastify";

const InputCompras = ({
  valor,
  onClick,
  handleChange = () => {},
  placeholder = "Buscar compra...",
  nombreCompra,
  editable = true,
  modo = "normal",
  id_entidad_proveedor = null,
  esRequerido = false
}) => {
  const compraNombre = nombreCompra || placeholder;
  const [mostrarModal, setMostrarModal] = useState(false);

  const handleClick = () => {
    if (modo === "NotaCreditoProveedor" && !id_entidad_proveedor) {
      toast.warn("Debe seleccionar un proveedor antes de buscar compras pendientes.");
      return;
    }
    setMostrarModal(true);
  };

  const BuscarValido = modo === "normal" || (modo === "ComprasPendientesPorProveedor" && id_entidad_proveedor != null);

  return (
    <>
      <button
        type="button"
        disabled={!editable}
        onClick={handleClick}
        className={`w-full flex items-center justify-between p-2 rounded-xl text-gray-700 border-2 bg-white outline-none transition-all ${
          esRequerido && editable
            ? 'border-red-200 hover:border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
            : 'border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
        }`}
      >
        <span className="truncate text-left">{compraNombre}</span>
        <FaSearch className="text-verde-claro ml-2" />
      </button>

      <PlantillaModal mostrar={mostrarModal} onClose={() => setMostrarModal(false)}>
        <TablaCompra modo="ComprasPendientesPorProveedor" id_entidad_proveedor={id_entidad_proveedor} 
         setCompraSeleccionada={(valores) => {
          handleChange(valores);
          setMostrarModal(false);
        }}/>
      </PlantillaModal>
    </>
  );
};

export default InputCompras;
